module.exports = __webpack_public_path__ + "img/upload.7ce46aef.png";